export var prepare = function (group, filters) {
    if (filters === void 0) { filters = []; }
    var filterIndex;
    var filter;
    var option;
    var attributes = [];
    if (!group) {
        return;
    }
    for (filterIndex = 0; filterIndex < filters.length; filterIndex++) {
        filter = filters[filterIndex];
        if (!filter.mandatory) {
            continue;
        }
        attributes = filterAttributes(filter, group.attributes);
        if (!attributes.length) {
            continue;
        }
        option = filterOptions(filter, attributes);
        if (option) {
            option.checked = true;
        }
    }
};
var filterAttributes = function (filter, attributes) {
    return attributes.filter(function (attributeItem) {
        var optionIndex;
        var currentOption;
        var hasOption = false;
        for (optionIndex = 0; optionIndex < filter.options.length; optionIndex++) {
            currentOption = filter.options[optionIndex];
            if (attributeItem.key === currentOption.key) {
                hasOption = true;
            }
            else {
                continue;
            }
        }
        return hasOption;
    });
};
var filterOptions = function (filter, attributes) {
    var productConnectivityAttributeKey = 'Product_Connectivity';
    return filter.options.filter(function (x) {
        if (x.key === productConnectivityAttributeKey) {
            return attributes.some(function (a) { return a.valueKey === x.value; });
        }
        else {
            return x.value === attributes[0].valueKey;
        }
    })[0];
};
